<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-card flat class="v-card-login mx-auto pt-4" round max-width="400">
          <v-card-text class="px-10">
            <v-form>
              <v-text-field
                v-model="value"
                :label="settingName"
                prepend-icon="settings"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="px-10">
            <v-btn @click="annuler" rounded color="primary">Annuler</v-btn>
            <v-spacer></v-spacer>

            <v-btn @click="updateParam" rounded color="primary"
              >Mettre à jour</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  created() {},

  data() {
    return {
      settingName: this.$route.params.settingName,
      value: this.$route.params.value,
    };
  },
  methods: {
    updateParam() {
      let self = this;
      let update = this.$firebase
        .firestore()
        .collection("options")
        .doc("VB08AelKInuKBr3fG6fM");
      // Set the "capital" field of the city 'DC'
      return update
        .update({
          [self.settingName]: self.value,
        })
        .then(function () {
          //console.log("Document successfully updated!");
          self.$router.push({ name: 'reglages' });
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
         
        });
    },

    annuler() {
      this.$router.back();
    },
  },
};
</script>

<style></style>
